import axios from "axios";

const {
  REACT_APP_LEGACY_RETURN_URL,
  REACT_APP_LEGACY_ACCUEIL_AGENT_URL,
  REACT_APP_LEGACY_MEMBRE_FICHE_URL,
  REACT_APP_LEGACY_MEMBRE_SUIVI_DEMANDE_URL,
  REACT_APP_LEGACY_SAISIE_DOSSIER_URL,
  REACT_APP_LEGACY_MEMBRE_DROITS_URL,
  REACT_APP_LEGACY_CONTACTER_NOUS_CHANGE_URL,
  REACT_APP_LEGACY_CONTACTER_NOUS_URL,
  REACT_APP_LEGACY_LOGIN_AGENT_URL,
  REACT_APP_LEGACY_PREFERENCE_BANCAIRES,
  REACT_APP_LEGACY_MODIF_MAIL,
  REACT_APP_LEGACY_MES_INFOS,
  REACT_APP_LEGACY_MODIF_PHONE
} = process.env;

export class LinkProviderService {

  getRetourEaMembrePrestation() {
         return REACT_APP_LEGACY_RETURN_URL;
  }

  getRetourEaAccueilAgent() {
        return REACT_APP_LEGACY_ACCUEIL_AGENT_URL;
  }

  getRetourEaMembreFiche() {
        return REACT_APP_LEGACY_MEMBRE_FICHE_URL;
  }

  getRetourEaMembreSuiviDemande() {
       return REACT_APP_LEGACY_MEMBRE_SUIVI_DEMANDE_URL;
  }

  getRetourEaSaisieDossier() {
       return REACT_APP_LEGACY_SAISIE_DOSSIER_URL;
  }

  getRetourEaMembreDroits() {
         return REACT_APP_LEGACY_MEMBRE_DROITS_URL;
  }

  getRetourEaContacterNousChangeSituations() {
         return REACT_APP_LEGACY_CONTACTER_NOUS_CHANGE_URL;
  }

  getRetourEaContacterNous() {
           return REACT_APP_LEGACY_CONTACTER_NOUS_URL;
  }

  getRetourEaLoginAgent() {
             return REACT_APP_LEGACY_LOGIN_AGENT_URL;
  }

  getRetourEaMesInfo() {
       return REACT_APP_LEGACY_MES_INFOS;
  }

  getRetourEaPreferenceBancaires() {
       return REACT_APP_LEGACY_PREFERENCE_BANCAIRES;
 }
  getEaModificationMail() {
          return REACT_APP_LEGACY_MODIF_MAIL;
  }
  getEaModificationPhone(){
        return REACT_APP_LEGACY_MODIF_PHONE;
  }
}
